var render = function render(_c, _vm) {
  return _c(
    "wa-question-and-answer",
    { attrs: { id: "dpf-details", title: "EU-U.S. DPF Statement and Policy" } },
    [
      _c("template", { slot: "copy" }, [
        _c("p", [
          _vm._v(
            "\n      This EU-U.S. DPF Statement and Policy (this “policy”) explains the rights and policies concerning Fonticons, Inc.’s (“we,” “our,” or the “company’s”)\n      collection, use, sale, and sharing of the personal information relating to any user (“you”) of our website, products, services, and other online tools\n      and resources. We may update and make changes to this policy, so we encourage you to review it periodically. This policy only addresses specific matters\n      concerning collection, use, sale, and sharing of certain personal information. The terms herein supplement and amend our other policies, including but\n      not necessarily limited to any of our other privacy policies. For additional information regarding how the company addresses privacy matters, please\n      review all of our posted policies. It is the intention of our policy to ensure compliance with EU-U.S. Data Privacy Framework, the UK Extension to the\n      EU-U.S. DPF, and the Swiss-U.S. Data Privacy Framework, and to safeguard the rights created and outlined therein as such rights relate to citizens of\n      the EU, UK, and Switzerland.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("ol", { attrs: { type: "1" } }, [
          _c("li", [
            _c("em", [_vm._v("Personal Data We Collect About You.")]),
            _vm._v(
              " We collect information to provide goods and/or services to you, to help improve your customer experience,\n        and to support our business functions. We may collect the following categories of consumer personal data:\n      "
            ),
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _c("em", [_vm._v("Identifiers:")]),
              _vm._v(
                " Information that identifies, relates to, describes, or is capable of being associated with, a particular individual such as\n          your name and email address.\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _c("em", [_vm._v("Commercial information:")]),
              _vm._v(
                " Purchase and transaction history, as well as information necessary to detect and prevent fraud when processing\n          payments.\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _c("em", [_vm._v("Quantitative Site Use:")]),
              _vm._v(
                " Information pertaining to your use of our site, such as page views, the source of your visit, views of content\n          during a visit, bandwidth utilized, stored video preferences, and information provided by you regarding your profile.\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", [_c("em", [_vm._v("Geolocation data.")])]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("em", [_vm._v("Why We Use Your Personal Information.")]),
            _vm._v(
              " We use your consumer personal information for the following business purposes:"
            ),
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _vm._v(
                "\n          Maintaining or servicing accounts, providing customer service, processing or fulfilling orders and transactions, verifying customer information,\n          processing payments, providing financing, providing analytic services, providing storage, or providing similar services;\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("Advertising or marketing;")]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "Helping to ensure security and integrity and prevent fraud;"
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "Undertaking activities to verify or maintain the quality or safety of our services or devices and to improve, upgrade, or enhance them;"
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v("Auditing or monitoring of transactions and engagements;"),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v("Compliance with our legal and regulatory obligations;"),
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("Conducting research and analysis;")]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "To conduct other activities for legitimate business purposes"
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("em", [_vm._v("Third Parties.")]),
            _vm._v(
              " The information described herein may be stored on servers owned by third parties in the ordinary course of business."
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("em", [_vm._v("Our Participation in the EU-U.S. DPF.")]),
          ]),
          _vm._v(" "),
          _c("ol", { staticStyle: { "list-style-type": "lower-roman" } }, [
            _c("li", [
              _vm._v(
                '\n          In order to comply with certain domestic and international legal requirements, we participate in the EU-U.S. Data Privacy Framework (the "EU-U.S.\n          DPF"). If you would like additional information regarding the EU-U.S. DPF other than what is contained in our Privacy Policy, such information is\n          available at\n          '
              ),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://www.dataprivacyframework.gov/",
                    target: "_blank",
                    rel: "noopener noreferrer",
                  },
                },
                [_vm._v("https://www.dataprivacyframework.gov/")]
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                '\n          As described herein, Fonticons, Inc., a Delaware corporation, with offices in the State of Arkansas and State of Missouri, collects certain personal\n          information (described above) and shares it with certain other parties (described above). As part of our participation in EU-U.S. DPF, we adhere to\n          certain Principles, as described on and defined by the EU-U.S. DPF website (the "Principles"). Any of our subsidiaries also adhere to such\n          Principles.\n        '
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "\n          It is the intention of this policy to ensure compliance with EU-U.S. Data Privacy Framework, the UK Extension to the EU-U.S. DPF, and the Swiss-U.S.\n          Data Privacy Framework, and to safeguard the rights created and outlined therein as such rights relate to citizens of the EU, UK, and Switzerland.\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "\n          Fonticons, Inc. complies with the EU-U.S. Data Privacy Framework (EU-U.S. DPF) and the UK Extension to the EU-U.S. DPF, and the Swiss-U.S. Data\n          Privacy Framework (Swiss-U.S. DPF) as set forth by the U.S. Department of Commerce. Fonticons, Inc. has certified to the U.S. Department of Commerce\n          that it adheres to the EU-U.S. Data Privacy Framework Principles (EU-U.S. DPF Principles) with regard to the processing of personal data received\n          from the European Union and the United Kingdom in reliance on the EU-U.S. DPF and the UK Extension to the EU-U.S. DPF. Fonticons, Inc. has certified\n          to the U.S. Department of Commerce that it adheres to the Swiss-U.S. Data Privacy Framework Principles (Swiss-U.S. DPF Principles) with regard to\n          the processing of personal data received from Switzerland in reliance on the Swiss-U.S. DPF. If there is any conflict between the terms in this\n          privacy policy and the EU-U.S. DPF Principles and/or the Swiss-U.S. DPF Principles, the Principles shall govern. To learn more about the Data\n          Privacy Framework (DPF) Program, and to view our certification, please visit\n          "
              ),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://www.dataprivacyframework.gov/",
                    target: "_blank",
                    rel: "noopener noreferrer",
                  },
                },
                [_vm._v("https://www.dataprivacyframework.gov/")]
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "\n          As described herein, Fonticons, Inc., a Delaware corporation, with offices in the State of Arkansas and State of Missouri, collects certain personal\n          information (described above) and shares it with certain other parties (described above). As part of our participation in EU-U.S. DPF, we adhere to\n          certain Principles, as described on and defined by the EU-U.S. DPF website (the “Principles”). Any of our subsidiaries also adhere to such\n          Principles.\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "We are committed to applying the Principles to all data we receive from the EU in reliance on the EU-U.S. DPF."
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "The purposes for which we collect certain personal data is described above."
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "\n          If you need to contact us, regarding inquiries, or complaints, you can reach us by email at\n          "
              ),
              _c("a", { attrs: { href: "mailto:dpo@awesome.me" } }, [
                _vm._v("dpo@awesome.me"),
              ]),
              _vm._v(" or "),
              _c("a", { attrs: { href: "mailto:privacy@fontawesome.com" } }, [
                _vm._v("privacy@fontawesome.com"),
              ]),
              _vm._v(", or by clicking Help on\n          any page at "),
              _c("a", { attrs: { href: "https://fontawesome.com/" } }, [
                _vm._v("https://fontawesome.com"),
              ]),
              _vm._v(
                '". In addition, certain EU officials and organizations may be able to\n          respond to your inquiries or complaints. You may find their contact information at\n          '
              ),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://edps.europa.eu/about-edps/contact_en",
                    target: "_blank",
                    rel: "noopener noreferrer",
                  },
                },
                [_vm._v("https://edps.europa.eu/about-edps/contact_en")]
              ),
              _vm._v("\n          or\n          "),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://edpb.europa.eu/about-edpb/more-about-edpb/contact-us_en",
                    target: "_blank",
                    rel: "noopener noreferrer",
                  },
                },
                [
                  _vm._v(
                    "https://edpb.europa.eu/about-edpb/more-about-edpb/contact-us_en"
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "As described herein, the information we retain may be stored on servers owned by third parties."
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "You have a right to access the data that we collect about you. If you would like to do so, please contact us via the methods listed above."
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "\n          Certain personal data, your email for example, is required for the use of our services. Therefore, if you do not wish for us to collect or store any\n          of your personal data, then we will be unable to provide services to you.\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "\n          An independent dispute resolution body is available to address complaints and provide recourse free of charge to you concerning the issues set forth\n          herein. Specifically, we have elected the JAMS Data Privacy Framework for disputes relating to EU-U.S. DPF. If you need to open a dispute resolution\n          matter relating to EU-U.S. DPF, information is available here:\n          "
              ),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://www.jamsadr.com/DPF-Dispute-Resolution",
                    target: "_blank",
                    rel: "noopener noreferrer",
                  },
                },
                [_vm._v("https://www.jamsadr.com/DPF-Dispute-Resolution")]
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "Our services, including the activities described herein, may be subject to the investigatory and enforcement powers of the FTC."
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "\n          By utilizing our services, you agree that, except as described herein and subject to the limitations of the laws of relevant jurisdictions, all\n          matters relating to EU-U.S. DPF shall be subject to binding arbitration. You may initiate binding arbitration in the event that any dispute\n          resolution procedures described by paragraph 4(xi) herein are unsuccessful. Information regarding initiating binding arbitration is available here:\n          "
              ),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://www.dataprivacyframework.gov/framework-article/ANNEX-I-introduction",
                    target: "_blank",
                    rel: "noopener noreferrer",
                  },
                },
                [
                  _vm._v(
                    "https://www.dataprivacyframework.gov/framework-article/ANNEX-I-introduction"
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "\n          In the event we receive a lawful request by a public or legal authority, such as a subpoena, we are required to abide by such requests and may be\n          required to disclose data containing your personal information, even if you would prefer that we do not make such disclosure. Such disclosures may\n          be required to be made in situations including, but not limited to, the necessity to meet national security or law enforcement requirements.\n        "
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "The rights and obligations contained in this Privacy Policy shall inure to the benefit or our, and your, heirs, successors, and assigns."
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("em", [_vm._v("Opting Out.")]),
            _vm._v(
              " You have the opportunity to choose to opt out of your personal information (i) being disclosed to a third party or (ii) being\n        used for a purpose that is materially different from the purpose(s) for which it was originally collected or subsequently authorized by the\n        individuals. To exercise such option, you can reach us by email at "
            ),
            _c("a", { attrs: { href: "mailto:dpo@awesome.me" } }, [
              _vm._v("dpo@awesome.me"),
            ]),
            _vm._v(" or\n        "),
            _c("a", { attrs: { href: "mailto:privacy@fontawesome.com" } }, [
              _vm._v("privacy@fontawesome.com"),
            ]),
            _vm._v(", or by clicking Help on any page at\n        "),
            _c("a", { attrs: { href: "https://fontawesome.com/" } }, [
              _vm._v("https://fontawesome.com"),
            ]),
            _vm._v(
              '". For your reference, we do not gather personal information specifying medical or\n        health conditions, racial or ethnic origin, political opinions, religious or philosophical beliefs, trade union membership or information specifying\n        the sex life of any individual\n      '
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("em", [_vm._v("Our Liability.")]),
            _vm._v(
              " The Recourse, Enforcement and Liability Principle of the Principles explains that, if we wrongfully transfer your data, we\n        have continuing responsibility for the processing of such personal information. In such case, we remain liable under the Principles if our agent\n        processes your personal information in a manner inconsistent with the Principles, unless we prove that we were not responsible for the event giving\n        rise to the damage.\n      "
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("em", [_vm._v("More Information.")]),
            _vm._v(
              " For more information concerning the Principles, please see\n        "
            ),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.dataprivacyframework.gov/program-articles/FAQs",
                  target: "_blank",
                  rel: "noopener noreferrer",
                },
              },
              [
                _vm._v(
                  "https://www.dataprivacyframework.gov/program-articles/FAQs"
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }